import React from "react";
import Table from "../../../components/table.jsx";
import { DocumentUpload } from "iconsax-react";

const CertificateTemplateTable = ({
  columns,
  filteredData,
  isMobile,
  handleUploadTemplate,
  pageChangeHandler,
  totalData,
  currentPage,
  totalRecords,
}) => (
  filteredData.length > 0 ? (
    <div 
      className="table-container"
      style={{ 
        overflowX: isMobile ? "auto" : "visible",
        marginBottom: isMobile ? "20px" : undefined,
        WebkitOverflowScrolling: isMobile ? "touch" : undefined
      }}
    >
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Header Section */}
        <div className="flex items-center px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <span className="text-xl font-bold text-gray-700">Total Templates: {totalRecords}</span>
          </div>
          <div className="flex-1 flex justify-center">
            <h2 className="text-xl font-bold text-gray-700">Certificate Template Details</h2>
          </div>
          <div className="flex items-center gap-4">
            {/* Upload Template Button */}
            <div className="flex items-center gap-2">
              <span className="text-gray-700 text-sm font-medium">Upload Template</span>
              <button
                onClick={handleUploadTemplate}
                className="flex items-center justify-center p-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                style={{
                  minHeight: "40px",
                  minWidth: "40px",
                }}
                title="Upload Template"
              >
                <DocumentUpload className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
        {/* Table Content */}
        <Table
          columns={columns}
          data={filteredData}
          title=""
          hasSearch={false}
          filters={columns.map((column) => column.accessor).filter(Boolean)}
          pageChangeHandler={pageChangeHandler}
          totalData={totalData}
          currentPage={currentPage}
        />
      </div>
    </div>
  ) : null
);

export default CertificateTemplateTable;